(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wonderly-mag-shelf"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('wlm-carousel')) {
    class WlmCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.wlm-shelf__track');
        this.bar = this.querySelector('.wlm-shelf__progress span');
        if (!this.track) return;
        this.interval = parseInt(this.dataset.interval, 10) || 4500;
        this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.autoplay = this.dataset.autoplay === 'true' && !this.reduced;
        this.paused = false; this.visible = false; this.holdUntil = 0;

        this.querySelectorAll('.wlm-arrow').forEach((btn) => {
          btn.addEventListener('click', () => { this.hold(); this.go(parseInt(btn.dataset.dir, 10)); });
        });
        this.track.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowRight') { e.preventDefault(); this.hold(); this.go(1); }
          if (e.key === 'ArrowLeft') { e.preventDefault(); this.hold(); this.go(-1); }
        });
        this.track.addEventListener('scroll', () => this.update(), { passive: true });
        ['pointerdown', 'touchstart', 'wheel'].forEach((ev) => this.track.addEventListener(ev, () => this.hold(), { passive: true }));
        this.addEventListener('mouseenter', () => { this.paused = true; this.classList.add('is-paused'); });
        this.addEventListener('mouseleave', () => { this.paused = false; this.classList.remove('is-paused'); });
        this.addEventListener('focusin', () => { this.paused = true; });
        this.addEventListener('focusout', () => { this.paused = false; });
        document.addEventListener('visibilitychange', () => { if (document.hidden) this.stop(); else this.start(); });
        if ('IntersectionObserver' in window) {
          this.io = new IntersectionObserver((entries) => {
            this.visible = entries[0].isIntersecting;
            this.visible ? this.start() : this.stop();
          }, { threshold: 0.35 });
          this.io.observe(this);
        } else { this.visible = true; this.start(); }
        window.addEventListener('resize', () => this.update(), { passive: true });
        this.update();
      }
      disconnectedCallback() { this.stop(); if (this.io) this.io.disconnect(); }
      step() {
        const card = this.track.firstElementChild;
        if (!card) return this.track.clientWidth;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        return card.getBoundingClientRect().width + gap;
      }
      atEnd() { return this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 4; }
      atStart() { return this.track.scrollLeft <= 4; }
      go(dir) {
        const behavior = this.reduced ? 'auto' : 'smooth';
        if (dir > 0 && this.atEnd()) return this.track.scrollTo({ left: 0, behavior });
        if (dir < 0 && this.atStart()) return this.track.scrollTo({ left: this.track.scrollWidth, behavior });
        this.track.scrollBy({ left: dir * this.step(), behavior });
      }
      hold() { this.holdUntil = Date.now() + this.interval * 2; }
      start() {
        if (!this.autoplay || this.timer || !this.visible) return;
        this.timer = setInterval(() => {
          if (this.paused || Date.now() < this.holdUntil) return;
          this.go(1);
        }, this.interval);
      }
      stop() { clearInterval(this.timer); this.timer = null; }
      update() {
        if (!this.bar) return;
        const max = this.track.scrollWidth - this.track.clientWidth;
        const visible = this.track.clientWidth / this.track.scrollWidth;
        const pos = max > 0 ? this.track.scrollLeft / max : 0;
        this.bar.style.width = (visible * 100).toFixed(2) + '%';
        this.bar.style.transform = 'translateX(' + (pos * (1 / visible - 1) * 100).toFixed(2) + '%)';
        this.classList.toggle('is-static', max <= 4);
      }
    }
    customElements.define('wlm-carousel', WlmCarousel);
  }

  } catch(e) { console.error(e); }
})();
})();
